import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { HistoryBoxService } from './services/history-box.service';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../../../../environments/environment';
import { Router } from '@angular/router';
import * as _ from 'lodash';
import { BsModalService, ModalDirective } from 'ngx-bootstrap/modal';
import * as moment from 'moment';
import { ExportService } from 'app/common/services/Export.service';
import { ModalDeleteComponent } from '../popup/confirmDelete/modalDelete.component';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';

declare function baseTracking(appId);

declare function enterScreenView(screenName: any, contentType: any, referrer: any);

declare function visibleContent(regionName: any, contentName: any, index: any);

declare function clickTracking(regionName: any, contentName: any, target: any, payload: any);

declare function searchEvent(keywords: any, params: any, order: any, sort: any)

declare var $: any;

@Component({
  selector: 'app-history-box',
  templateUrl: './history-box.component.html',
  styleUrls: ['./history-box.component.css'],
  providers: [HistoryBoxService],
})
export class HistoryBoxComponent implements OnInit {
  page_title = '';
  queryListHistoryBox: any = {};
  formListHistoryBox = this.fb.group({
    box_serial: '',
    actor: null,
    lot_stamp: null,
    createdDate: null,
  });
  pageIndexLIstHistoryBox = 1;
  pageSizeLIstHistoryBox = 10;
  list_data_historyBox = [];
  total_data_historyBox = 0;
  loadingListHistoryBox: boolean = false;

  listBatchStamps: any = [];

  // chi tiet 1 đóng thùng
  id_detail: string;
  data_detail: any;
  loadingDataDetail: boolean = false;
  form = this.fb.group({
    serial: null,
    lotId: null,
    productId: null,
    status: null,
    boxTypeId: null,
  });
  pageIndexStamp = 1;
  pageSizeStamp = 10;
  query_list_stamp: any;
  list_stamp_in_box = [];
  total_stamp_in_box = 0;
  loadingListStampInBox: boolean = false;
  status_stamp = [];
  isDistribution: Boolean = false;
  isList: Boolean = true;
  stasitic: any;
  lotem: string;
  listBatches = [
    {
      label: 'Lo 1',
      value: 1,
    },
    {
      label: 'Lo 2',
      value: 2,
    },
  ];
  data = [
    {
      id: 'IC-000999',
      total: 29,
      created_time: '20/20/2020 12:00:00',
    },
    {
      id: 'IC-000999',
      total: 29,
      created_time: '20/20/2020 12:00:00',
    },
  ];
  item_active: any;
  totalPage: number;

  boxTypeList: any = [];
  /** Tuanba:18/10/2022: Thông tin bóc thùng **/
  unboxTypeList: any = [];
  public pageIndexUnbox = 1;
  public pageSizeUnbox = 10;
  public totalInforUnbox: any;
  public dataInfoUnbox: any;
  public bundleId: any;
  public checkEmptyUnBox: any;
  public lengthDataInforUnbox: any;

  constructor(
    private historyBoxService: HistoryBoxService,
    private fb: FormBuilder,
    private toastr: ToastrService,
    public router: Router,
    private exportService: ExportService,
    private modalService: BsModalService,
    private translateService: TranslateService,
  ) {
  }

  ngOnInit() {
    baseTracking(environment.appIdTracking);
    enterScreenView('qcheck_package_view', 'others', '')
    this.isDistribution = false;
    this.isList = true;

    this.translateService.onLangChange.subscribe(() => {
      this.initTranslations();
    });
    this.initTranslations();

    this.getListBoxType();
    this.getListBatches();
    this.statistics();
    // this.loadListHistoryBox();
  }

  initTranslations() {
    this.page_title = this.translateService.instant('LICH_SU_DONG_THUNG');
    this.status_stamp = [
      {
        label: this.translateService.instant('TAT_CA_TRANG_THAI'),
        value: '',
      },
      {
        label: this.translateService.instant('CHUA_XAC_NHAN'),
        value: 1,
      },
      {
        label: this.translateService.instant('DA_XAC_NHAN'),
        value: 2,
      },
      {
        label: this.translateService.instant('YEU_CAU_TRA_HANG'),
        value: 3,
      },
      {
        label: this.translateService.instant('DA_TRA_HANG_1'),
        value: 4,
      },
    ];
    this.unboxTypeList = [
      {
        value: 0,
        name: this.translateService.instant('PHAN_PHOI_1'),
      },
      {
        value: 1,
        name: this.translateService.instant('THU_HOI_1'),
      },
      {
        value: 2,
        name: this.translateService.instant('TRA_HANG_1'),
      },
    ];

    $('#userIdCreated').select2({
      placeholder: this.translateService.instant('NGUOI_THUC_HIEN'),
      allowClear: true,
      minimumInputLength: 1,
      ajax: {
        delay: 1500,
        url: `${environment.qrcode_url}/user/search`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('Access-Token')}`,
          'Content-Type': 'application/json',
        },
        dataType: 'json',
        data: function (params) {
          return {
            keyword: params.term || '',
            page: 1,
            page_size: 50,
          };
        },
        processResults: (data) => {
          if (data.data !== null) {
            return {
              results: data.data.items.map((item) => {
                return {
                  text: item.name,
                  id: item.userId,
                };
              }),
            };
          }
          return [];
        },
      },
    });

    $('#lotIdStamp').select2({
      placeholder: this.translateService.instant('LO_TEM_1'),
      allowClear: true,
    });

    $('#box_type_inbox_pr').select2({
      placeholder: this.translateService.instant('HINH_THUC_DONG_GOI'),
      allowClear: true,
      minimumResultsForSearch: -1,
    });

    this.initBoxTypeSelect();
    this.initUnBoxTypeSelect();
    if (this.id_detail) {
      this.initSelectBatchItems(this.id_detail);
    }
  }

  statistics() {
    this.historyBoxService.statistics().subscribe((res) => {
      if (res.code === 1) {
        this.stasitic = res.data;
      }
    });
  }

  getListBoxType() {
    this.historyBoxService.listBoxType().subscribe(
      (res) => {
        if (res.code === 1) {
          this.boxTypeList = res.data.map((item) => {
            return {
              value: item.type,
              label: item.name,
            };
          });
        } else {
          this.boxTypeList = [];
        }
        this.loadListHistoryBox();
      },
      (err) => {
        this.boxTypeList = [];
        this.loadListHistoryBox();
        console.log(err);
      }
    );
  }

  loadListHistoryBox() {
    let opt: any = {};
    if (this.queryListHistoryBox.createdDate) {
      opt.start = this.getDate(this.queryListHistoryBox.createdDate[0]);
      opt.end = this.getDate(this.queryListHistoryBox.createdDate[1]);
    }
    opt.page = this.pageIndexLIstHistoryBox;
    opt.page_size = this.pageSizeLIstHistoryBox;
    if ($('#userIdCreated').val()) {
      opt.actor = $('#userIdCreated').val();
    }
    if ($('#lotIdStamp').val()) {
      opt.lot_stamp = $('#lotIdStamp').val();
    }
    if ($('#box_type_inbox_pr').val()) {
      opt.box_type = $('#box_type_inbox_pr').val();
    }
    if (
      this.queryListHistoryBox.box_serial &&
      this.queryListHistoryBox.box_serial.trim()
    ) {
      opt.stamp_code = this.queryListHistoryBox.box_serial.trim();
    }
    this.historyBoxService.getList(opt).subscribe(
      (res) => {
        if (res.code === 1 && res.data.items) {
          this.list_data_historyBox = res.data.items.map((item: any) => {
            let tmpItem = Object.assign({}, item);
            let serial: any;
            if (item.prefix) {
              if (item.idStart === item.idEnd) {
                serial = this.formatSerial(item.idStart, item.prefix);
              } else {
                serial = this.formatSerial(item.idStart, item.prefix) + ' -> ' + this.formatSerial(item.idEnd, item.prefix);
              }
              tmpItem.serial = serial;
            }
            let boxTypeObj = this.boxTypeList.find((gg: any) => {
              if (gg) {
                return gg.value === item.boxType;
              } else {
                return null;
              }
            });
            if (boxTypeObj) {
              tmpItem.boxTypeObj = boxTypeObj;
            }
            return tmpItem;
          });
          this.total_data_historyBox = res.data.totalElement;
          if (this.list_data_historyBox && this.list_data_historyBox.length) {
            const first_item = this.list_data_historyBox[0];
            this.viewDetail(first_item.bundleId);
          }
          return;
        }
        this.list_data_historyBox = [];
        this.total_data_historyBox = 0;
      },
      (error) => {
        this.list_data_historyBox = [];
        this.total_data_historyBox = 0;
      }
    );
  }

  getListBatches() {
    this.historyBoxService.getListBatchesStamp().subscribe((res) => {
      if (res.code === 1) {
        // console.log('res.data',res.data)
        if (res.data.items !== null) {
          this.listBatchStamps = res.data.items.map((item: any) => {
            return {
              text: item.name,
              id: item.id,
            };
          });
        }
      }
    });
  }

  searchListHistoryBox() {
    let opt: any = {};
    if (this.queryListHistoryBox.createdDate) {
      opt.start = this.getDate(this.queryListHistoryBox.createdDate[0]);
      opt.end = this.getDate(this.queryListHistoryBox.createdDate[1]);
    }
    if ($('#userIdCreated').val()) {
      opt.actor = $('#userIdCreated').val();
    }
    if ($('#lotIdStamp').val()) {
      opt.lot_stamp = $('#lotIdStamp').val();
    }
    if ($('#box_type_inbox_pr').val()) {
      opt.box_type = $('#box_type_inbox_pr').val();
    }
    if (
      this.queryListHistoryBox.box_serial &&
      this.queryListHistoryBox.box_serial.trim()
    ) {
      opt.stamp_code = this.queryListHistoryBox.box_serial.trim();
    }
    console.log('vào ko tar', opt);
    searchEvent(JSON.stringify(opt), JSON.stringify(opt), '', '');
    this.pageIndexLIstHistoryBox = 1;
    this.loadListHistoryBox();
  }

  resetListHistoryBox() {
    this.queryListHistoryBox = {};
    this.pageIndexLIstHistoryBox = 1;
    this.isDistribution = false;
    $('#userIdCreated').val('').trigger('change');
    $('#lotIdStamp').val('').trigger('change');
    $('#box_type_inbox_pr').val('').trigger('change');
    this.loadListHistoryBox();
  }

  // load page danh sach lịch sử đóng thùng
  prePageListHistoryBox() {
    if (this.pageIndexLIstHistoryBox > 1) {
      this.pageIndexLIstHistoryBox = this.pageIndexLIstHistoryBox - 1;
      this.loadListHistoryBox();
    }
  }

  lastPageListHistoryBox() {
    if (
      this.pageIndexLIstHistoryBox * this.pageSizeLIstHistoryBox <
      this.total_data_historyBox
    ) {
      this.pageIndexLIstHistoryBox = this.pageIndexLIstHistoryBox + 1;
      this.loadListHistoryBox();
    }
  }

  inputPageListHistoryBoxChange(event) {
    // tslint:disable-next-line:radix
    const page = parseInt(event.target.value);
    if (page % 1 === 0 && page > 0 && page !== this.pageIndexLIstHistoryBox) {
      this.pageIndexLIstHistoryBox = page;
      this.loadListHistoryBox();
    }
  }

  loadListStampInBox() {
    let opt: any = {
      page: this.pageIndexStamp,
      page_size: this.pageSizeStamp,
    };
    if ($('#bash_detail').val()) {
      opt.batch_id = $('#bash_detail').val().toString();
    }
    if ($('#box_type_inbox').val()) {
      opt.box_type = $('#box_type_inbox').val();
    }
    if (this.form.get('serial').value && this.form.get('serial').value.trim()) {
      opt.stamp_code = this.form.get('serial').value.trim();
    }
    if (this.id_detail) {
      opt.box_id = this.id_detail;
    }

    this.historyBoxService.getListStampInBox(opt).subscribe(
      (res) => {
        if (res.code === 1 && res.data.items) {
          this.list_stamp_in_box = res.data.items.map((item: any) => {
            return {
              id: item.id,
              bathName: item.bathName,
              prefix: item.prefix,
              startId: item.startId,
              endId: item.endId,
              productName: item.productName,
              serialStart: this.formatSerial(item.startId, item.prefix),
              serialEnd: this.formatSerial(item.endId, item.prefix),
              totalBox: item.totalBox,
              totalStamp: item.totalStamp,
              bundleType: item.bundleType,
              boxType: item.boxType,
            };
          });
          console.log(this.list_stamp_in_box);
          this.total_stamp_in_box = res.data.totalElement;
          return;
        }
        this.list_stamp_in_box = [];
        this.total_stamp_in_box = 0;
      },
      (error) => {
        this.list_stamp_in_box = [];
        this.total_stamp_in_box = 0;
      }
    );
  }

  clickSerialTracking(serial) {
    clickTracking('qcheck_package_view', 'serial', 'qcheck_stamp_check', serial)
  }


  search() {
    let opt: any = {
      page: this.pageIndexStamp,
      page_size: this.pageSizeStamp,
    };
    let tracking: any = {}
    if ($('#bash_detail').val()) {
      opt.batch_id = $('#bash_detail').val().toString();
      tracking.batch_id = $('#bash_detail').val().toString();
    }
    if ($('#box_type_inbox').val()) {
      opt.box_type = $('#box_type_inbox').val();
      tracking.box_type = $('#box_type_inbox').val();
    }
    if (this.form.get('serial').value && this.form.get('serial').value.trim()) {
      opt.stamp_code = this.form.get('serial').value.trim();
      tracking.stamp_code = this.form.get('serial').value.trim();
    }
    if (this.id_detail) {
      opt.box_id = this.id_detail;
      tracking.box_id = this.id_detail;
    }
    searchEvent(JSON.stringify(tracking), JSON.stringify(tracking), '', '');
    this.pageIndexStamp = 1;
    this.loadListStampInBox();
  }

  reset() {
    $('#status').val('').trigger('change');
    $('#box_type_inbox').val('').trigger('change');
    $('#bash_detail').val('').trigger('change');
    this.pageIndexStamp = 1;
    this.form.reset();
    this.loadListStampInBox();
  }


  // load page danh sach lịch sử đóng thùng
  prePageListStampInBox() {
    if (this.pageIndexStamp > 1) {
      this.pageIndexStamp = this.pageIndexStamp - 1;
      this.loadListStampInBox();
    }
  }

  lastPageListStampInBox() {
    if (this.pageIndexStamp * this.pageSizeStamp < this.total_stamp_in_box) {
      this.pageIndexStamp = this.pageIndexStamp + 1;
      this.loadListStampInBox();
    }
  }

  inputPageListStampInBox(event) {
    // tslint:disable-next-line:radix
    const page = parseInt(event.target.value);
    if (page % 1 === 0 && page > 0 && page !== this.pageIndexStamp) {
      this.pageIndexStamp = page;
      this.loadListStampInBox();
    }
  }


  viewDetailTracking() {
    console.log(this.id_detail);
    clickTracking('qcheck_package_view', 'package_detail', 'package_detail', this.id_detail);
    visibleContent('qcheck_package_view', 'package_detail', '');
  }

  changeDistribution() {
    this.isDistribution = true;
    // this.loadingDataDetail = true
    this.isList = false;
  }

  initSelectBatchItems(boxId: string) {
    $('#bash_detail').select2({
      placeholder: this.translateService.instant('LO_TEM_PLACEHOLDER'),
      allowClear: true,
      minimumResultsForSearch: Infinity,
      ajax: {
        delay: 1000,
        url: `${environment.qrcode_url}/box/batch?boxId=${boxId}`,
        headers: {
          authorization: localStorage.getItem('Access-Token'),
          'Content-Type': 'application/json',
        },
        dataType: 'json',
        data: function (params) {
          if (params.term) {
            return {
              name: params.term,
              offset: 0,
              limit: 50,
            };
          }
          return {
            offset: 0,
            limit: 50,
          };
        },
        processResults: function (data) {
          if (data.data) {
            return {
              results: data.data.map((item) => {
                return {
                  text: item.name,
                  id: item.batchId,
                };
              }),
            };
          } else {
            return {
              results: [],
            };
          }
        },
      },
    });
  }

  getDate(date) {
    const today = new Date(date);
    let dd: any = today.getDate();
    let mm: any = today.getMonth() + 1;
    const yyyy = today.getFullYear();
    if (dd < 10) {
      dd = '0' + dd;
    }
    if (mm < 10) {
      mm = '0' + mm;
    }
    return yyyy + '-' + mm + '-' + dd;
  }

  formatSerial(id: any, prefix: string) {
    let serial_f: string = '';
    id = id.toString();
    if (id && prefix) {
      let pad = '000000';
      let serial = pad.substring(0, 6 - id.length) + id;
      serial_f = prefix + '-' + serial;
    }
    return serial_f;
  }

  searchInfoSerial(code: string) {
    this.router.navigate(['/find-stamp'], { queryParams: { code } });
    // let url = this.router.serializeUrl(
    //   this.router.createUrlTree(["/find-stamp"], { queryParams: { code } })
    // );
    // window.open(url, "_blank");
  }

  initBoxTypeSelect() {
    $('#box_type_inbox').select2({
      placeholder: this.translateService.instant('HINH_THUC_DONG_GOI_PLACEHOLDER'),
      allowClear: true,
      minimumResultsForSearch: -1,
    });
  }

  public queryInfoUnbox = {
    createdDate: undefined,
    name: '',
    type: undefined

  }

  viewDetail(event) {
    this.bundleId = event;
    $('#status').val('').trigger('change');
    this.form.reset();
    $('#bash_detail').val('').trigger('change');
    this.initSelectBatchItems(event);
    if (this.isDistribution === true) {
      this.toastr.warning(this.translateService.instant('THAO_TAC_DA_HUY'), this.translateService.instant('THONG_BAO'), {
        timeOut: 4000,
        positionClass: 'toast-top-right',
      });
    }
    this.isDistribution = false;
    this.isList = true;
    this.id_detail = event;
    this.pageIndexStamp = 1;
    let query = {
      id: event,
    };
    this.loadingDataDetail = true;
    this.historyBoxService.getDetail(query).subscribe(
      (res) => {
        if (res.code === 1) {
          this.data_detail = res.data;
          this.data_detail.id = event;
          this.checkEmptyUnBox = res.data.isBoxExclude;
          if (res.data.prefix) {
            this.data_detail.serialStart = this.formatSerial(res.data.idStart, res.data.prefix);
            this.data_detail.serialEnd = this.formatSerial(res.data.idEnd, res.data.prefix);
            if (res.data.idStart === res.data.idEnd) {
              this.data_detail.serial = this.data_detail.serialStart;
            } else {
              this.data_detail.serial = this.data_detail.serialStart + ' -> ' + this.data_detail.serialEnd;
            }
          }
          let boxTypeObj = this.boxTypeList.find((item: any) => {
            if (item) {
              return item.value === res.data.boxType;
            } else {
              return null;
            }
          });
          if (boxTypeObj) {
            this.data_detail.boxTypeObj = boxTypeObj;
          }
          this.loadingDataDetail = false;
        } else {
          this.loadingDataDetail = false;
          this.toastr.warning(res.message, this.translateService.instant('THONG_BAO'), {
            timeOut: 4000,
            positionClass: 'toast-top-right',
          });
          this.data_detail = null;
        }
      },
      (error) => {
        this.data_detail = error.data;
        this.loadingDataDetail = false;
      }
    );

    this.initBoxTypeSelect();
    this.initUnBoxTypeSelect();
    this.loadListStampInBox();
    this.getListDetailUnbox();
  }

  /** Tuanba:18/10/2022: Thông tin bóc thùng **/

  initUnBoxTypeSelect() {
    $('#unbox_type_inbox').select2({
      placeholder: this.translateService.instant('HANH_DONG_PLACEHOLDER'),
      allowClear: true,
      minimumResultsForSearch: -1,
    });
  }

  getDateUnbox(date) {
    const today = new Date(date);
    let dd: any = today.getDate();
    let mm: any = today.getMonth() + 1;
    const yyyy = today.getFullYear();
    if (dd < 10) {
      dd = '0' + dd;
    }
    if (mm < 10) {
      mm = '0' + mm;
    }
    return dd + '/' + mm + '/' + yyyy;
  }


  searchUnbox() {
    let body: any = {
      page: this.pageIndexUnbox,
      page_size: this.pageSizeUnbox,
    };
    if (this.queryInfoUnbox.name && this.queryInfoUnbox.name.trim()) {
      body.serial = this.queryInfoUnbox.name.trim();
    }
    if (this.queryInfoUnbox.createdDate) {
      body.from = this.getDate(this.queryInfoUnbox.createdDate[0]);
      body.to = this.getDate(this.queryInfoUnbox.createdDate[1]);
    }
    if ($('#unbox_type_inbox').val()) {
      body.transferType = $('#unbox_type_inbox').val();
    }
    this.getListDetailUnbox();
    this.pageIndexUnbox = 1;
  }

  async getListDetailUnbox() {
    this.initUnBoxTypeSelect();
    let body: any = {
      page: this.pageIndexUnbox,
      pageSize: this.pageSizeUnbox
    };
    if (this.queryInfoUnbox.name && this.queryInfoUnbox.name.trim()) {
      body.serial = this.queryInfoUnbox.name.trim();
    }
    if (this.queryInfoUnbox.createdDate) {
      body.from = this.getDateUnbox(this.queryInfoUnbox.createdDate[0]);
      body.to = this.getDateUnbox(this.queryInfoUnbox.createdDate[1]);
    }
    if ($('#unbox_type_inbox').val()) {
      body.transferType = $('#unbox_type_inbox').val();
    }
    const bundleId = this.bundleId;
    await this.historyBoxService.getDetailUnbox(bundleId, body).subscribe((res) => {
      console.log(res);
      this.totalInforUnbox = res.data.totalElement;
      this.lengthDataInforUnbox = res.data.items.length;
      this.dataInfoUnbox = _.groupBy(res.data.items, 'createdDate');
      this.dataInfoUnbox = Object.keys(this.dataInfoUnbox).map(key => this.dataInfoUnbox[key]);
      this.dataInfoUnbox.map((item) => {
        return item.map((val) => {
          if (val.prefix) {
            val.serialStart = this.formatSerial(val.idStart, val.prefix);
            val.serialEnd = this.formatSerial(val.idEnd, val.prefix);
          }
        })
      })
    }, (error) => {
      this.toastr.error(error.message, this.translateService.instant('THONG_BAO'), {
        timeOut: 3000,
        positionClass: 'toastr-right-bottom'
      })
    })
  }


  prePageListUnBox() {
    if (this.pageIndexUnbox > 1) {
      this.pageIndexUnbox = this.pageIndexUnbox - 1;
      this.getListDetailUnbox();
    }
  }

  lastPageListUnBox() {
    console.log(this.pageIndexUnbox * this.pageSizeUnbox, this.totalInforUnbox)
    if (this.pageIndexUnbox * this.pageSizeUnbox < this.totalInforUnbox) {
      this.pageIndexUnbox = this.pageIndexUnbox + 1;
      this.getListDetailUnbox();
    }
  }

  inputPageListUnBox(event) {
    // tslint:disable-next-line:radix
    const page = parseInt(event.target.value);
    if (page % 1 === 0 && page > 0 && page !== this.pageIndexUnbox) {
      this.pageIndexUnbox = page;
      this.getListDetailUnbox();
    }
  }

  resetSearchUnbox() {
    this.pageIndexUnbox = 1;
    this.queryInfoUnbox = {
      createdDate: undefined,
      name: '',
      type: undefined
    }
    $('#unbox_type_inbox').val('').trigger('change');
    this.getListDetailUnbox();
  }

  /**  Tuanba: 25-7-2025 : Bổ sung báo cáo**/
  // Export Alert
  public messageExport: any = '';

  exportReport() {
    this.messageExport = '';
    $('.stampBoxStampAlertAdd').css('opacity', '0');
    const timePicker = $('.timePicker');
    const created_time_val = $('.timePicker').val();
    const listDate = created_time_val.toString().split(' - ');
    console.log('listDate', listDate)
    if (created_time_val) {
      if (listDate.length > 1) {
        const a = listDate[0].split('/');
        const resultFrom = a[2] + '-' + a[1] + '-' + a[0];
        const b = listDate[1].split('/');
        const resultTo = b[2] + '-' + b[1] + '-' + b[0];
        const resultFromDate = moment(`${resultFrom}`)
        const resultToDate = moment(`${resultTo}`)
        const validateResult = resultToDate.diff(resultFromDate, 'days') + 1
        console.log('validateResult', validateResult)
        if (validateResult > 31) {
          this.validateDownloadExcelPopup.show();
          return;
        }
      }
    } else {
      this.validateDownloadExcelPopup.show();
      return;
    }
    let opt: any = {};
    if (this.queryListHistoryBox.createdDate) {
      opt.start = timePicker.val().split('-')[0]
        ? timePicker.val().split('-')[0].trim()
        : ''
      opt.end = timePicker.val().split('-')[1]
        ? timePicker.val().split('-')[1].trim()
        : '';
    }
    opt.page = this.pageIndexLIstHistoryBox;
    opt.page_size = this.pageSizeLIstHistoryBox;
    if ($('#userIdCreated').val()) {
      opt.actor = $('#userIdCreated').val();
    }
    if ($('#lotIdStamp').val()) {
      opt.lot_stamp = $('#lotIdStamp').val();
    }
    if ($('#box_type_inbox_pr').val()) {
      opt.box_type = $('#box_type_inbox_pr').val();
    }
    if (
      this.queryListHistoryBox.box_serial &&
      this.queryListHistoryBox.box_serial.trim()
    ) {
      opt.stamp_code = this.queryListHistoryBox.box_serial.trim();
    }
    console.log('isSorting.typeSort ')
    const body = {
      exportTypeEnum: 'BOX_HISTORY',
      fields: opt
    };
    this.exportService.exportReport(body).subscribe((res) => {
      if (res.code == 1) {
        this.messageExport = this.translateService.instant('XUAT_FILE_THANH_CONG_VUI_LONG_KIEM_TRA_TRONG_QUAN_LY_BAO_CAO');
        $('.stampBoxStampAlertAdd').css('opacity', '1');
        setTimeout(() => {
          $('.stampBoxStampAlertAdd').css('opacity', '0');
        }, 5000);
      } else {
        this.toastr.error(res.message, this.translateService.instant('THONG_BAO'), {
          timeOut: 4000,
          positionClass: 'toast-bottom-right'
        })
      }
    }, (error) => {
      this.toastr.error(error.message, 'Thông báo', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      })
    });
  }

  @ViewChild('validateDownloadExcelPopup') validateDownloadExcelPopup: ModalDirective;

  closeModalValidateExport() {
    this.validateDownloadExcelPopup.hide();
  }

  /** Tuanba: 23-9-2025: Thêm modal xóa thùng có trạng thái Chưa phân phối → tem thùng**/
  bsModalRef: BsModalRef;

  showPopupDelete() {
    this.data_detail.name = this.data_detail.serial
    const initialState = {
      item: this.data_detail,
    };
    this.bsModalRef = this.modalService.show(ModalDeleteComponent, {
      initialState,
    });
    this.bsModalRef.content.btnClose = this.translateService.instant('HUY_BO');
    this.bsModalRef.content.btnConfirm = this.translateService.instant('XAC_NHAN');
    this.bsModalRef.content.cModalTitle = this.translateService.instant('XAC_NHAN_XOA_1');
    this.bsModalRef.content.cModalContent = this.translateService.instant('BAN_CHAC_CHAN_MUON_XOA_THUNG');
    this.bsModalRef.content.idDelete.subscribe(async (id: string | number) => {
      if (id) {
        console.log('id', id)
        this.historyBoxService
          .deleteBox(id)
          .toPromise()
          .then((res: any) => {
            console.log('res', res)
            if (res.code == 1) {
              const mess = this.translateService.instant('XOA_THUNG_THANH_CONG');
              this.toastr.success(mess, this.translateService.instant('THANH_CONG'), {
                timeOut: 4000,
                positionClass: 'toast-top-right',
              });
              this.loadListHistoryBox();
            } else {
              const mess = res.message
                ? res.message
                : 'Thao tác chưa thành công. Vui lòng thử lại sau!';
              this.toastr.warning(mess, this.translateService.instant('THONG_BAO'), {
                timeOut: 4000,
                positionClass: 'toast-top-right',
              });
            }
          })
          .catch((err: any) => {
            const mess = this.translateService.instant('CO_LOI_XAY_RA');
            this.toastr.warning(mess, this.translateService.instant('THONG_BAO'), {
              timeOut: 4000,
              positionClass: 'toast-top-right',
            })
          });
      }
      this.closeModalFromParent()
    });
  }

  closeModalFromParent() {
    // Gọi trực tiếp hàm public onCloseModal()
    (this.bsModalRef.content as ModalDeleteComponent).onCloseModal();
  }

  formatStatistic(statisticObj: any): string {
    if (!statisticObj) return '';
    const parts = [];
    if (statisticObj.container) parts.push(`${statisticObj.container} công-te-nơ`);
    if (statisticObj.palet) parts.push(`${statisticObj.palet} pallet`);
    if (statisticObj.carton) parts.push(`${statisticObj.carton} thùng`);
    if (statisticObj.box) parts.push(`${statisticObj.box} hộp`);
    if (statisticObj.product) parts.push(`${statisticObj.product} tem sản phẩm`);
    return parts.join(', ');
  }

  exportDetailStampInBox() {
    const body: any = {};
    if ($('#bash_detail').val()) {
      body.batch_id = $('#bash_detail').val().toString();
    }
    if ($('#box_type_inbox').val()) {
      body.box_type = $('#box_type_inbox').val();
    }
    if (this.form.get('serial').value && this.form.get('serial').value.trim()) {
      body.stamp_code = this.form.get('serial').value.trim();
    }
    this.exportService.exportDetailStampBox(this.id_detail, body).subscribe((res) => {
      const url = window.URL.createObjectURL(res);
      const element = document.createElement('a');
      document.body.appendChild(element);
      element.href = url;
      element.download = this.translateService.instant('LICH_SU_DONG_THUNG') + '.xlsx';
      element.click();
      window.URL.revokeObjectURL(url);

    }, (error) => {
      this.toastr.error(error.message, 'Thông báo', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      })
    });
  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/history-box/history-box.component.ts